<template>
  <div>
    <!-- 声音设置 -->
    <modalDefault :showModal="showModal" @close="close()" @confirm="confirm()" modalText="设置" :showCancel="false"
      :showConfirm="false" btnStyle="bottom: 5px;">
      <template #dialogContent>
        <div class="dialog-content-box clearfix">
          <div class="dialog-middle-content">
            <div class="row-box">
              <div class="left-text">
                <!-- <img src="../../assets/images/switch_bg.png" alt="" mode="aspectFit" /> -->
                <div class="text">游戏音效</div>
              </div>
              <!-- <div @click="effect = !effect" class="switch-bar on" v-if="effect">
                <span class="text">关</span>
                <div class="switch-handle active">开</div>
              </div>
              <div @click="effect = !effect" class="switch-bar" v-else>
                <span class="text">开</span>
                <div class="switch-handle">关</div>
              </div> -->
              <el-switch v-model="effect" active-color="#0DD3FA" inactive-color="#808080">
              </el-switch>
            </div>
            <div class="row-box">
              <div class="left-text">
                <!-- <img src="../../assets/images/switch_bg.png" alt="" mode="aspectFit" /> -->
                <div class="text">背景音乐</div>
              </div>
              <!-- <div @click="music = !music" class="switch-bar on" v-if="music">
                <span class="text">关</span>
                <div class="switch-handle active">开</div>
              </div>
              <div @click="music = !music" class="switch-bar" v-else>
                <span class="text">开</span>
                <div class="switch-handle">关</div>
              </div> -->
              <el-switch v-model="music" active-color="#0DD3FA" inactive-color="#808080">
              </el-switch>
            </div>
          </div>
        </div>
      </template>
      <template #customBtn>
        <div class="bottom-box" @click="confirm">
          <!-- <img src="../../assets/images/bottom_line_1.png" alt="" class="line-img" mode="aspectFit" /> -->
          <div class="btn submit-btn">确认</div>
        </div>
      </template>
    </modalDefault>
  </div>
</template>
<script>
import modalDefault from "@/components/common/modalDefault.vue";
export default {
  name: "modalSetting",
  components: {
    modalDefault,
  },
  data() {
    return {
      effect: true,
      music: true,
    };
  },
  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    init() {
      let effect = localStorage.getItem("effect");
      let music = localStorage.getItem("music");
      effect = effect === null ? true : JSON.parse(effect);
      music = music === null ? true : JSON.parse(music);
      this.effect = effect;
      this.music = music;
    },
    close() {
      this.$emit("close");
    },
    confirm() {
      this.$emit('confirm', this.effect, this.music)
    },
  },
  watch: {
    showModal(newVal) {
      if (newVal) {
        console.log("showModal", newVal);
        this.init();
      }
    },
  }
};
</script>
<style lang="scss" scoped>
.title {
  width: 100%;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.title img {
  width: 13.47 * 4.2px;
  height: 6.13 * 4.2px;
}

.common-small-dialog-content {
  min-height: -webkit-fit-content !important;
  min-height: -moz-fit-content !important;
  min-height: fit-content !important;
}

.dialog-content-box {
  width: 80 * 4.2px;
  height: 58 * 4.2px;
  position: relative;

  @media only screen and (max-width: 430px) {
    width: 80vw;
    height: 58vw;
  }
}

.dialog-content-box .dialog-close-btn {
  width: 14 * 4.2px;
  height: 7.73 * 4.2px;
  position: absolute;
  top: -6.67 * 4.2px;
  right: 0;
}

.dialog-content-box .dialog-middle-content {
  width: 100%;
  height: auto;

  background-color: #302077;
  border-radius: 1.19 * 4.2px;
  margin-top: 4.76 * 4.2px;
  padding: 3.76 * 4.2px 0;


  @media only screen and (max-width: 430px) {
    border-radius: 1.19vw;
    margin-top: 4.76vw;
    padding: 3.76vw 0;
  }
}

.dialog-content-box .row-box {
  width: 100%;
  height: 8 * 4.2px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  font-size: 3.33 * 4.2px;
  font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
  font-weight: 400;
  color: #FFFFFF;
  -webkit-box-pack: center;
  -webkit-justify-content: space-between;
  -ms-flex-pack: center;
  justify-content: space-between;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  // margin-bottom: 6.67 * 4.2px;
  padding: 0 2.38 * 4.2px;

  @media only screen and (max-width: 430px) {
    height: 8vw;
    font-size: 3.33vw;
    // margin-bottom: 6.67vw;
    padding: 0 2.38vw;
  }
}

.dialog-content-box .row-box .left-text {
  margin-right: 2.4 * 4.2px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.dialog-content-box .row-box .left-text img {
  width: 6.67 * 4.2px;
  height: 5.2 * 4.2px;
  margin-right: 0.27 * 4.2px;
}

.bottom-box {
  width: 100%;
  height: 24 * 4.2px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  position: relative;
}

.bottom-box .line-img {
  width: 73.2 * 4.2px;
  height: 2.67 * 4.2px;
  position: absolute;
  left: 3.2 * 4.2px;
  top: 25px;
}

.bottom-box .btn {
  width: 33.38 * 4.2px;
  height: 8.8 * 4.2px;
  line-height: 8.8 * 4.2px;
  // margin-top: 64px;
  text-align: center;
  background: url("../../assets/image3/home/btnBack.png") no-repeat 0 0;
  background-size: 100% 100%;
  font-size: 3.33 * 4.2px;
  color: #ffffff;

  @media only screen and (max-width: 430px) {
    width: 33.38vw;
    height: 8.8vw;
    line-height: 8.8vw;
    font-size: 3.33vw;
  }
}

.switch-bar {
  position: relative;
  display: inline-block;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 30 * 4.2px;
  height: 8 * 4.2px;
  line-height: 8 * 4.2px;
  background: url("../../assets/images/switch-bar.png") no-repeat 0 0;
  background-size: 30 * 4.2px 8 * 4.2px;
  text-align: right;
  -webkit-transition: all 0.3s ease-in-out;
  -o-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
}

.switch-bar .text {
  margin: 0 6.93 * 4.2px;
  font-size: 4.4 * 4.2px;
  color: #8599ff;
}

.switch-bar .switch-handle {
  position: absolute;
  left: 3.33 * 4.2px;
  top: -0.93 * 4.2px;
  width: 11.33 * 4.2px;
  height: 10 * 4.2px;
  -webkit-border-radius: 50%;
  border-radius: 50%;
  background: url("../../assets/images/switch-handle.png") no-repeat 0 0;
  background-size: 11.33 * 4.2px 10 * 4.2px;
  -webkit-transition: all 0.3s ease-in-out;
  -o-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
  text-align: center;
  line-height: 10 * 4.2px;
}

.switch-bar .switch-handle.active {
  background-image: url("../../assets/images/btn_1-active.png");
}

.on {
  color: #fff;
  text-align: left;
}

.on .switch-handle {
  -webkit-transform: translateX(11.33 * 4.2px);
  -ms-transform: translateX(11.33 * 4.2px);
  transform: translateX(11.33 * 4.2px);
}

.disabled {
  background-color: #e5e5e5;
  cursor: not-allowed;
}

.disabled .switch-handle {
  background-color: #f2f2f2;
}

.disabled-on .switch-handle {
  background-color: #f9f9f9;
}

.disabled-on:before {
  content: "";
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.5);
}
</style>